import {useQuery} from '@tanstack/react-query';

import {fetch} from '../services/ProviderMappingsService';
import {providerMappingsQueryKeys} from './providerMappingsQueryKeys';

// The detail page's one record. Read-only: the module has no edit path, and a
// mapping's provider-facing fields are written by create and by the provider sync.
export const useProviderMapping = (id?: string) => {
    const query = useQuery({
        queryKey: providerMappingsQueryKeys.detail(id),
        queryFn: () => fetch(id!),
        enabled: !!id,
    });

    return {
        record: query.data ?? null,
        loading: query.isLoading,
        isError: query.isError,
    };
};
